import { tv } from '@workspace/lib';

export const productSummaryVariants = tv({
  slots: {
    container: 'px-md py-xl md:px-full-banner md:py-3xl',
    wrapper: '',
    media: 'h-81.75 md:size-136',
    content: 'gap-sm md:gap-lg',
    heading: 'text-black',
    description: 'gap-8 md:max-w-175',
    hyperlink: 'text-primary font-semibold text-base leading-md',
    hyperlinkIcon: 'text-primary',
    video: 'h-81.75 w-full md:size-136',
    placeholder: 'h-81.75 w-full md:h-136',
  },
  variants: {
    layoutStyle: {
      normal: {
        wrapper: 'gap-lg md:gap-3xl',
        content: 'flex-1',
      },
      medium: {
        wrapper: 'justify-between',
        content: 'md:flex-initial md:w-auto md:max-w-144',
        description: 'md:max-w-144',
      },
      large: {
        wrapper: 'justify-between',
        content: 'flex-1',
      },
    },
    imagePosition: {
      left: {},
      right: {},
    },
  },
  defaultVariants: {
    layoutStyle: 'normal',
    imagePosition: 'left',
  },
});
